export const environment = {
  production: true,
  siteId: 2,
  apiUrl: 'https://api.adkey-seo.com/api',
  imagesUrl: 'https://api.adkey-seo.com/storage/images/',
};
